var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "registerForm",
      attrs: { model: _vm.form, rules: _vm.rules },
      nativeOn: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("p", { staticClass: "orangetext" }, [
        _vm._v(
          "\n        Fill in your new password in the two fields below to change it.\n    "
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "password",
                    error: _vm.$t(_vm.formErrors.get("password")),
                    rules: [
                      {
                        required: true,
                        message: "Password is required",
                        trigger: "blur",
                      },
                      {
                        min: 8,
                        message: "Password should be at least 8 characters",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("auth.register.password_label") + "*",
                      name: "password",
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-group",
                  attrs: {
                    prop: "password_confirmation",
                    rules: [
                      {
                        required: true,
                        message: "Password Confirmation is required",
                        trigger: "blur",
                      },
                      {
                        validator: _vm.validatePassConfirmation,
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("auth.register.password_confirmation_label") +
                        "*",
                      name: "password_confirmation",
                      "show-password": "",
                    },
                    model: {
                      value: _vm.form.password_confirmation,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "password_confirmation", $$v)
                      },
                      expression: "form.password_confirmation",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { sm: 24, md: 12 } }, [
            _vm._v("\n             \n        "),
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "text-right", attrs: { sm: 24, md: 12 } },
            [
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.onSubmit.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n                Change Password\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }